import { generateCostsFromLineItems } from '../helpers/costs'

export default {
  fields: {
    costs: {
      read: generateCostsFromLineItems,
    },
  },
}
